import { type ApplicantDetailed } from '../API/GET/applicant/response';
import { type UpdateApplicant } from '../API/PUT/applicant/request';

export const convertToPutApplicant = (
  applicant: ApplicantDetailed
): UpdateApplicant => {
  const { currState, keyEmp, note, prefTime, ...putApplicant } = applicant;

  return {
    ...putApplicant,
    keyEmp: keyEmp.id,
    note: note === '' ? null : note,
    prefTime: prefTime === '' ? null : prefTime,
  };
};
